import {
  FETCH_PRODUCTRETURNDETAILS_SUCCESS_ACTION,
  FETCH_PRODUCTRETURNSEARCH_SUCCESS_ACTION,
  FETCH_PRODUCTRETURNVIEW_SUCCESS_ACTION,
  FETCH_PRODUCTRETURNVIEW_INIT_ACTION,
  FILTER_BY_PRODUCTRETURN_STATUS_SUCCESS_ACTION
} from "./action";

const initialState = {
  processing: false,
  error: false
};

export default function(state: any = initialState, action: Function) {
  switch (action.type) {
    case FETCH_PRODUCTRETURNDETAILS_SUCCESS_ACTION:
      // console.log(
      //   "&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&",
      //   action.payload.rows
      // );
      return {
        ...state,
        ProductReturnDtlsList: action.payload.rows,
        ProductReturnlsCount: action.payload.count
      };
    case FETCH_PRODUCTRETURNSEARCH_SUCCESS_ACTION:
      return {
        ...state,
        ProductReturnSearchList: action.payload.rows,
        ProductReturnSearchCount: action.payload.count
      };

    case FILTER_BY_PRODUCTRETURN_STATUS_SUCCESS_ACTION:
      return {
        ...state,
        productuserFilterList: action.payload.rows,
        productuserFilterCount: action.payload.count
      };

    case FETCH_PRODUCTRETURNVIEW_SUCCESS_ACTION:
      // console.log("&&&&&ProductReturnDtls&&&&&&&&&&&&&&", action.payload.rows);
      return {
        ...state,

        ProductReturnls: action.payload.rows,
        ProductReturnDtlsCount: action.payload.count
      };
    case FETCH_PRODUCTRETURNVIEW_INIT_ACTION:
      return {
        ...state,
        ProductReturnDtls: {}
      };

    default:
      return {
        ...state
      };
  }
}
